import React from "react";
import DisplayCompanyInfo from "./DisplayCompanyInfo";
import { getValue } from "../CommonUtils";
import { useSelector, useDispatch } from "react-redux";
import { EditCompanyProfileInfo, ResetEditCompanyProfile } from "../../../store/actions/Settings/EditCompanyInfo";
import { GetCustomerUserandCompanyProfileData } from "../../../store/actions/Settings/CustomerUser&CompanyProfileData";
import { usePermissions } from "../../Hook";
import { hasPermission } from "hooks/usePermission";
import { UserAdditionalInfo } from "../../../store/actions/UserAdditionalInfo";

const initialCompanyInfo = {
  companyName: "",
  email: "",
  contactPerson: "",
  industry: "",
  contactNumber: "",
};

const compInfo = [
  {
    title: "Company name",
    value: null,
    name: "companyName",
    type: "text",
    isRequired: true,
  },
  {
    title: "Industry",
    value: null,
    name: "industry",
    type: "text",
  },
  {
    title: "Email address",
    value: null,
    name: "email",
    type: "text",
    isRequired: true,
  },
  {
    title: "Contact number",
    value: null,
    name: "contactNumber",
    type: "number",
  },
  {
    title: "Contact person",
    value: null,
    name: "contactPerson",
    type: "text",
  },
];

const initailModal = {
  modalName: null,
  edit: false,
};

function CompanyInfo(props) {
  const { title } = props;
  const dispatch = useDispatch();
  const { loggedInUser } = usePermissions();

  const [companyInfo, setCompanyInfo] = React.useState(initialCompanyInfo);
  const [editAbleModal, setEditAbleModal] = React.useState(initailModal);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [saveInfo, setSaveInfo] = React.useState(false);
  const [displaycompanyInfo, setDisplayCompanyInfo] = React.useState(compInfo);

  const CompanyProfileData = useSelector(
    (state) => state.CustomerUserandCompanyProfileData.customerUserandCompanyProfileData
  );

  const editCompanyInfo = useSelector((state) => state.EditCompanyInfo.editCompanyInfo);

  const handleInputChange = (fieldName, value) => {
    setCompanyInfo((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const hanldeEdit = (editableModal) => {
    setEditAbleModal({
      modalName: editableModal,
      edit: true,
    });
  };

  const handleSave = () => {
    handleSaveInfo();
  };

  const handleCancel = (modalName) => {
    setEditAbleModal({
      modalName,
      edit: false,
    });
  };

  const handleSaveInfo = () => {
    setSaveInfo(true);

    if (companyInfo.companyName != "" && companyInfo.email) {
      setOpenAlert(false);
      dispatch(
        EditCompanyProfileInfo({
          companyProfileData: companyInfo,
          customerId: loggedInUser?.userId,
        })
      );
    } else {
      setOpenAlert(true);
    }
  };

  React.useEffect(() => {
    let currentUser = {};
    currentUser = JSON.parse(localStorage.getItem("loggedInUser"));

    const getProfileDataRequest = `customerUser/${currentUser?.userId}`;
    if (editCompanyInfo?.ok) {
      setEditAbleModal({
        modalName: null,
        edit: false,
      });
      dispatch(UserAdditionalInfo(`customer/${currentUser?.customerId}/info`));
      dispatch(
        GetCustomerUserandCompanyProfileData({
          request: getProfileDataRequest,
        })
      );
      dispatch(ResetEditCompanyProfile({}));
    }
  }, [editCompanyInfo]);

  React.useEffect(() => {
    if (CompanyProfileData?.ok) {
      const companyName = getValue(CompanyProfileData?.payload?.customer?.companyName);
      const email = getValue(CompanyProfileData?.payload?.customer?.contactEmail);
      const contactNumber = getValue(CompanyProfileData?.payload?.customer?.contactNumber);
      const industry = getValue(CompanyProfileData?.payload?.customer?.industry);
      const contactPerson = getValue(CompanyProfileData?.payload?.customer?.contactPerson);

      setCompanyInfo({
        companyName,
        email,
        contactNumber,
        industry,
        contactPerson,
      });

      // `compInfo` is a module-level constant shared across renders/instances, so it must
      // never be mutated in place and handed back to setState with the same reference:
      // React bails out of re-rendering when the new state is Object.is-equal to the
      // current state, which left these fields permanently blank on screen even though
      // the data had loaded successfully. Build a brand new array/objects instead.
      const fieldValues = { companyName, industry, email, contactNumber, contactPerson };
      setDisplayCompanyInfo((prevFields) =>
        prevFields.map((field) => ({
          ...field,
          value: fieldValues[field.name] ?? field.value,
        }))
      );
    }
  }, [CompanyProfileData]);

  return (
    <DisplayCompanyInfo
      data={displaycompanyInfo}
      title={title}
      fieldsData={companyInfo}
      hanldeEdit={hanldeEdit}
      editAbleModal={editAbleModal}
      handleInputChange={handleInputChange}
      handleCancel={handleCancel}
      handleSave={handleSave}
      icon
      bgColor="#F2FFFB"
      iconColor="#00C0AF"
      open={openAlert}
      setOpenAlert={setOpenAlert}
      editCompanyInfo={editCompanyInfo}
      saveInfo={saveInfo}
      canEdit={hasPermission("customers.update")}
    />
  );
}

export default CompanyInfo;
